import React from 'react';

import { Button, Card, CardContent, CardHeader, Divider, Stack, Typography } from '@mui/material';

import { useEva } from '../../hooks/useEva';

type Props = {
  strategyId: string;
  lastUpdated: string;
};

export const PublishEvaSection: React.FC<Props> = ({ strategyId, lastUpdated }) => {
  const { loading, onPublishToEva, onUpdateInEva } = useEva(strategyId);
  return (
    <Card>
      <CardHeader title="Публикация в Ева" />
      <Divider />
      <CardContent>
        <Stack spacing={1}>
          <Stack direction="row" spacing={1}>
            <Button variant="contained" disabled={loading} onClick={onPublishToEva} aria-label="Опубликовать">
              Опубликовать
            </Button>
            <Button variant="contained" disabled={loading} onClick={onUpdateInEva} aria-label="Обновить">
              Обновить
            </Button>
          </Stack>
          <Typography variant="body2">Последнее обновление: {lastUpdated}</Typography>
        </Stack>
      </CardContent>
    </Card>
  );
};
